import { errorToast } from 'utils/toast';

import { COPILOT_BAR_MAX_ATTACHMENTS_TOTAL_SIZE, MARKDOWN_BOLD_REGEX } from './constants';

// Tool callback utilities
const formatToolArguments = ({ tool }) => {
    if (!tool?.arguments) return '';

    const args = typeof tool.arguments === 'string' ? JSON.parse(tool.arguments) : tool.arguments;
    const formattedArgs = Object.entries(args).map(([key, value]) => `**${key}**: ${value}`);

    if (formattedArgs.length <= 1) return formattedArgs[0] ?? '';

    const lastArg = formattedArgs.pop();
    return `${formattedArgs.join(', ')} & ${lastArg}`;
};

export const createToolInitPhrase = ({ t, tool }) => {
    const args = formatToolArguments({ tool });
    const phrase = args
        ? t('label_copilot_tool_initializing_with_args', [tool?.name, args])
        : t('label_copilot_tool_initializing', [tool?.name]);

    return { phrase };
};

export const createToolDonePhrase = ({ t, tool }) => {
    return { phrase: t('label_copilot_tool_finishing', [tool?.name]) };
};

/**
 * Loading phrase for CopilotBar while files upload to S3 (matches UploadFilesDialog literals).
 * @param {Function} t - Translation function from Web5Context
 * @param {number} fileCount - Number of files being uploaded
 * @returns {string} Localized loading phrase
 */
export const getFileUploadLoadingPhrase = (t, fileCount) => {
    if (fileCount === 1) return `${t('label_uploading_file_singular')}...`;
    return `${t('label_uploading_file', [fileCount])}...`;
};

/**
 * @param {Array<{ size?: number }>} files
 * @returns {number}
 */
export const getFilesTotalSize = (files = []) =>
    files.reduce((total, file) => total + (file?.size || 0), 0);

/**
 * @param {Array<{ size?: number }>} files
 * @param {number} [maxTotalSize]
 * @returns {boolean}
 */
export const areCopilotFilesWithinTotalSizeLimit = (
    files,
    maxTotalSize = COPILOT_BAR_MAX_ATTACHMENTS_TOTAL_SIZE,
) => getFilesTotalSize(files) <= maxTotalSize;

/**
 * Matches EmailEditor attachment size validation toasts.
 * @param {Function} t - Translation function from Web5Context
 */
export const showCopilotAttachmentsTotalSizeExceededToast = (t) => {
    errorToast({
        t,
        title: t('error_loading_file_title'),
        text: t('error_loading_file_desc_max_size_copilot'),
    });
};

export const processLiveMarkdown = (text) => {
    return text.replace(MARKDOWN_BOLD_REGEX, '<b>$1</b>');
};

export const processStaticMarkdown = (textBox) => {
    if (!textBox) return;

    const htmlText = textBox.innerHTML;
    const newText = htmlText.replace(MARKDOWN_BOLD_REGEX, '<b>$1</b>');
    textBox.innerHTML = newText;
};
